var _g, _path, _g2, _path2, _path3, _g3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchivedProposalsEmptyState = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 205,
  height: 188,
  fill: "none",
  viewBox: "0 0 205 188"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ArchivedProposalsEmptyState_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ArchivedProposalsEmptyState_svg__b)",
  d: "m179.354 73.792-74.84-19.817c-2.323-.87-5.608-.197-6.968 1.165l-75.657 76.063c-.457.459-1.174.71-1.23 1.516-.107 1.548 1.916 4.595 3.397 4.991l79.07 21.187c1.858.498 4.468-.203 5.828-1.565l75.118-75.6c2.015-2.609-2.86-7.442-4.718-7.94"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M178.499 73.569 104.351 53.7c-3.201-.858-7.695.346-10.038 2.69l-72.331 72.33c-2.344 2.343-1.648 4.938 1.553 5.796l72.216 19.35c4.268 1.144 10.26-.462 13.385-3.586l70.916-70.917c2.344-2.343 1.648-4.938-1.553-5.795"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ArchivedProposalsEmptyState_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ArchivedProposalsEmptyState_svg__d)",
  d: "M109.721 151.717 180.49 79.67c2.185-2.225 1.654-4.681-1.218-5.639l-2.742-.914-71.617-18.867c-3.197-.842-7.664.359-10.002 2.69l-72.559 72.322c-2.33 2.323-1.675 4.901 1.468 5.783l72.357 20.289c4.296 1.204 10.412-.429 13.544-3.617"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#ArchivedProposalsEmptyState_svg__e)",
  d: "M178.499 73.569 104.351 53.7c-3.201-.858-7.695.346-10.038 2.69l-72.331 72.33c-2.344 2.343-1.648 4.938 1.553 5.796l72.216 19.35c4.268 1.144 10.26-.462 13.385-3.586l70.916-70.917c2.344-2.343 1.648-4.938-1.553-5.795"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3F0FF",
  d: "M61.415 97.591c.819-.74 2.345-1.1 3.409-.803l69.339 19.385c1.064.297 1.263 1.139.443 1.88l-5.933 5.367c-.819.741-2.345 1.1-3.409.803l-69.34-19.385c-1.063-.297-1.262-1.139-.443-1.88zM76.239 81.114c.82-.741 2.346-1.1 3.41-.804l69.339 19.385c1.064.298 1.262 1.139.443 1.88l-5.933 5.367c-.819.741-2.346 1.101-3.41.803l-69.34-19.384c-1.063-.298-1.261-1.14-.442-1.88z"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ArchivedProposalsEmptyState_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ArchivedProposalsEmptyState_svg__g)",
  d: "M149.277 65.503c-3.625 3.625-10.617 5.646-15.618 4.515-2.131-.482-3.556-1.46-4.209-2.703-1.943-3.48-.36-3.83 1.72-5.91 3.625-3.624 10.617-5.646 15.617-4.515 2.068.468 3.197.028 4.15 2.593.646 1.74.466 3.894-1.66 6.02"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4926CD",
  d: "M91.357 124.562c-.192-.43-.878-.601-1.524-.762l-70.12-17.412c-.907-.243-2.403.294-3.612 1.241-.458.359-.891.732-1.4 1.065l-4.825 3.165c-1.45 1.16-.44 3.54.634 3.828l71.48 19.153c1.073.288 2.973-.52 4.244-1.804l4.601-4.65c.946-.956.937-2.894.522-3.824"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6942F8",
  d: "m90.612 124.8-71.48-19.153c-1.074-.288-2.974.52-4.245 1.804l-4.601 4.65c-1.271 1.284-1.43 2.558-.357 2.845l71.48 19.153c1.074.288 2.973-.519 4.245-1.804l4.601-4.649c1.271-1.285 1.43-2.558.357-2.846"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFD",
  d: "m31.789 114.631-1.264.715-.99-.265 6.006-3.34 1.09.292-1.802 4.467-1.013-.272.4-.947zm2.724-.059.825-1.952-2.602 1.476zm5.577.447-.147-.039a2.2 2.2 0 0 0-1.141-.005q-.563.15-.964.552l-1.403 1.403-.866-.232 2.885-2.885.866.232-.424.424q.45-.165.878-.202.44-.04.82.062l.147.039zm.152 3.017q-.595-.16-.884-.488a.88.88 0 0 1-.214-.746q.075-.418.499-.841a3.4 3.4 0 0 1 1.04-.697 4.3 4.3 0 0 1 1.3-.34 3.6 3.6 0 0 1 1.28.091q.58.156.866.476a.85.85 0 0 1 .223.727l-1.083.133a.53.53 0 0 0-.118-.44q-.16-.194-.5-.285a2.1 2.1 0 0 0-.744-.049q-.397.045-.769.211a2 2 0 0 0-.607.411q-.249.249-.303.499a.53.53 0 0 0 .118.441q.166.195.507.286.34.092.737.047a2.6 2.6 0 0 0 .763-.204l.416.534a4.2 4.2 0 0 1-1.276.326 3.5 3.5 0 0 1-1.251-.092m7.838-1.73q.703.189.817.614.122.426-.393.942l-1.816 1.815-.866-.231 1.607-1.607q.334-.334.261-.604-.058-.274-.507-.394a1.83 1.83 0 0 0-.966.006q-.49.127-.824.461l-1.595 1.595-.866-.232 4.073-4.073.866.232-1.578 1.578q.945-.327 1.787-.102m3.489.404q-.232-.062-.28-.218-.037-.16.133-.33a.96.96 0 0 1 .443-.247 1 1 0 0 1 .507-.008q.24.065.281.219.05.156-.126.332a1 1 0 0 1-.45.245.96.96 0 0 1-.508.007m-.92.371.866.232-2.885 2.885-.865-.232zm1.259 3.995-.897-.24 1.208-3.334.99.265-.961 2.41 3.256-1.796.965.259zm7.495.187a3 3 0 0 1-.272.242l-3.191-.855q-.204.34-.05.618t.633.406q.37.1.8.071a3 3 0 0 0 .778-.15l.22.525a4.5 4.5 0 0 1-1.222.232 3.7 3.7 0 0 1-1.171-.113q-.618-.165-.922-.498a.9.9 0 0 1-.238-.752q.072-.426.503-.855.418-.419 1.034-.691a4.3 4.3 0 0 1 1.287-.337q.677-.07 1.256.086.588.157.861.481a.87.87 0 0 1 .199.742q-.075.417-.505.848m-.655-.52q.205-.333.069-.599-.123-.269-.548-.383a1.95 1.95 0 0 0-.913-.008q-.49.098-.904.375zm4.052 3.252-.865-.232.412-.413q-.479.165-.959.195a2.8 2.8 0 0 1-.904-.085q-.55-.147-.8-.465a.85.85 0 0 1-.152-.73q.098-.41.522-.835a3.6 3.6 0 0 1 1.017-.703 4.2 4.2 0 0 1 1.238-.357q.647-.078 1.195.069.425.114.656.334a.75.75 0 0 1 .247.518l1.6-1.601.866.232zm-1.857-2.327q-.249.248-.304.5a.53.53 0 0 0 .118.44q.16.193.507.287.34.09.737.046.398-.044.756-.206a2 2 0 0 0 .62-.415q.25-.249.29-.496a.5.5 0 0 0-.104-.444q-.16-.194-.5-.284a2 2 0 0 0-.744-.049q-.397.043-.769.21a2 2 0 0 0-.607.411"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ArchivedProposalsEmptyState_svg__b",
  x1: 185.79,
  x2: 12.445,
  y1: 72.549,
  y2: 30.274,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8B98DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#C1CBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.304,
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.333,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492,
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.857,
  stopColor: "#94A0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAE0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ArchivedProposalsEmptyState_svg__d",
  x1: 184.942,
  x2: -144.761,
  y1: 68.186,
  y2: 494.955,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ArchivedProposalsEmptyState_svg__e",
  x1: 184.362,
  x2: -145.341,
  y1: 67.605,
  y2: 494.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ArchivedProposalsEmptyState_svg__g",
  x1: 156.328,
  x2: 146.515,
  y1: 58.564,
  y2: 46.471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7EAF8"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ArchivedProposalsEmptyState_svg__a",
  width: 203.896,
  height: 163.473,
  x: 0.655,
  y: 23.585,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_40062_295482",
  result: "effect2_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_40062_295482",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ArchivedProposalsEmptyState_svg__c",
  width: 162.877,
  height: 103.749,
  x: 19.957,
  y: 52.981,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_40062_295482",
  stdDeviation: 0.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "ArchivedProposalsEmptyState_svg__f",
  width: 62.699,
  height: 53.756,
  x: 108.568,
  y: 40.576,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_40062_295482"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_40062_295482",
  result: "shape"
})))));
export default SvgArchivedProposalsEmptyState;